import { Link } from "react-router-dom";

export function TrialBanner({
  trialEndsAt,
  monitoredAsinCount,
  skuCap,
  scrapeCadence,
}: {
  trialEndsAt: string | null | undefined;
  monitoredAsinCount: number;
  skuCap: number | null | undefined;
  scrapeCadence: string;
}) {
  const daysLeft = trialEndsAt
    ? Math.max(
        0,
        Math.ceil((new Date(trialEndsAt).getTime() - Date.now()) / (24 * 60 * 60 * 1000))
      )
    : null;

  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-5 dark:border-emerald-900 dark:bg-emerald-950/40">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="text-sm text-emerald-900 dark:text-emerald-200">
          <div className="font-semibold">
            Trial · {daysLeft !== null ? `${daysLeft} days left` : "active"}
          </div>
          <div className="mt-1 text-emerald-800 dark:text-emerald-300">
            Monitoring {monitoredAsinCount}
            {skuCap ? ` of ${skuCap}` : ""} SKUs · {scrapeCadence} scrape cadence ·
            takedown submissions included
          </div>
        </div>
        <Link
          to="/pricing"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 dark:bg-emerald-500 dark:hover:bg-emerald-600"
        >
          Upgrade →
        </Link>
      </div>
    </div>
  );
}
